var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#1C202D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5517 21.9546H23.5487C20.0724 21.9546 18 23.0424 18 27.9647V42.99C18 47.9258 20.0724 49.0001 23.5487 49.0001H31.5422C35.0185 49.0001 37.0909 47.9122 37.0909 42.99V27.9647C37.1004 23.0424 35.028 21.9546 31.5517 21.9546Z",
    fill: "#FEB444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0943 14H41.0974C44.5737 14 46.6461 15.0878 46.6366 20.0101V35.0354C46.6366 39.9576 44.5642 41.0455 41.0879 41.0455H38.9721C38.9721 41.0452 38.9721 41.045 38.9721 41.0447V26.0194C38.9721 21.4375 35.9375 20.0093 33.433 20.0093H27.5457C27.5459 15.0877 29.6182 14 33.0943 14Z",
    fill: "#FEB444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollection);
export default __webpack_public_path__ + "static/media/collection.ac052b314d6bce38219a916a3433a039.svg";
export { ForwardRef as ReactComponent };